const initialFilterState = {
  search: '',
  category: null
}

export default {
  namespaced: true,
  state: {
    filter: {...initialFilterState},
    pagination: {
      offset: 0,
      limit: 10
    }
  },
  mutations: {
    setFilter(state, value) {
      state.filter = value;
      state.pagination.offset = 0;
    },
    setPagination(state, value) {
      state.pagination = value;
    },
    resetFilter(state) {
      state.filter = initialFilterState;
    }
  },
  actions: {
    setPagination({commit}, value) {
      return commit('setPagination', value);
    },
    setFilterSearch({commit, state}, search) {
      return commit('setFilter', {...state.filter, search});
    },
    setFilterCategory({commit, state}, category) {
      return commit('setFilter', {...state.filter, category});
    },
    resetFilter({commit}) {
      return commit('resetFilter');
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/collectionsModule.js